import { render, staticRenderFns } from "./Addaddress.vue?vue&type=template&id=a04effd6&scoped=true&"
import script from "./Addaddress.vue?vue&type=script&lang=js&"
export * from "./Addaddress.vue?vue&type=script&lang=js&"
import style0 from "./Addaddress.vue?vue&type=style&index=0&id=a04effd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04effd6",
  null
  
)

export default component.exports